import { render, staticRenderFns } from "./DownArrow.vue?vue&type=template&id=0a70d5be&scoped=true"
var script = {}
import style0 from "./DownArrow.vue?vue&type=style&index=0&id=0a70d5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70d5be",
  null
  
)

export default component.exports